<template>
    <Typography
        v-if="ratingInfo"
        type="label"
        size="xs"
        :responsive="false"
        :class="$style.age_rating"
        :style="{
            '--color': ratingInfo.textColor,
            '--background-color': ratingInfo.backgroundColor,
        }"
    >
        {{ ratingInfo.label }}
    </Typography>
</template>
<script lang="ts" setup>
import { computed } from 'vue'

import Typography from '@/components/Typography.vue'
import { useI18nAddon } from '@/i18n/i18n'
import { AgeRating } from '@/types'

import { AGE_RATING_CONFIG } from './constants'

const props = defineProps<{
    rating: AgeRating | undefined
}>()

const { currentLocale } = useI18nAddon()

const ratingInfo = computed(() => props.rating && AGE_RATING_CONFIG[props.rating]?.[currentLocale.value])
</script>
<style module>
.age_rating {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 20px;
    font-weight: 500;
    color: var(--color);
    padding: 0 6px;
    border-radius: 6px;
    background-color: var(--background-color);
}
</style>
